'use strict';

import createSlot from "~/helpers/createSlot";
import TimerWidget from "~/components/TimerWidget";
import Image from "~/components/Image";

export const ControlsSlot = createSlot();
export const TitleSlot = createSlot();
export const ContainerSlot = createSlot();

export default function SearchListItem({
    item: {tags, aircraft, prices, is_emptyleg}, 
    tags: additionalTags = [],
    imageSize = undefined,
    className = undefined,

    onClick,

    children,
}) {
    const image = imageSize && aircraft.images && aircraft.images[imageSize] && aircraft.images[imageSize].length > 0 ? aircraft.images[imageSize][0] : null

    const isDiscount = !!(prices.previous_price);

    return <div className={cn("flight", className)}>
        
        <ContainerSlot.Renderer childs={children}>
            <a role='button' className="flight-link" onClick={onClick}></a>
        </ContainerSlot.Renderer>

        <div className="flight-img">
            <Image src={image} alt={aircraft.title} errorStyle={{ objectFit: "contain", padding: "2em"}} />

            <div className="el-flight-tags">
                {additionalTags.concat(tags || []).map(tag => <span key={tag.value}>{tag.label}</span>)}
            </div>
        </div>
        <div className="flight-desc">
            <div className="el-flight-title">
                <h3>
                    { aircraft.title}
                    <span> </span>
                    {is_emptyleg && <sup className="el-tooltip" data-tooltip="Empty Leg"> el</sup>}
                </h3>
                
                <TitleSlot.Renderer childs={children} />
            </div>
            <div className="flight-planes">
                {!!(aircraft.year || aircraft.update) && <div>
                    {!!aircraft.year ? aircraft.year + ' ' : ''}
                    {!!aircraft.update && <i className="el-tooltip" data-tooltip={tMsg('Обновление салона')}>
                        {`(${aircraft.update})`}
                    </i>}
                </div>}
                <div>{aircraft.class.title}</div>
            </div>
            
            <div className="flight-row">
                <FacilitiesList aircraft={aircraft} /> 
            </div>
        </div>
        <div className="flight-control">
            <ControlsSlot.Renderer childs={children} />
            
            <div className="flight-price">
                {!isDiscount && `${prices.prefix}${prices.price.formatPrice(prices.currency.code)}`}
                {isDiscount && <React.Fragment>
                    <div className="flight-price__old">{prices.previous_price.formatPrice(prices.previous_currency)}</div>
                    <div className="flight-price__discount">{prices.price.formatPrice(prices.currency.code)}</div>
                </React.Fragment>}
            </div>
        </div>
    </div>
}

function FacilitiesList({ aircraft }) {
    switch (aircraft._version) {
        case undefined:
            return <React.Fragment>
                <Facility title={tMsg('Мест')} value={aircraft.params.seats} />
                <Facility title={tMsg('Выс.салона')} value={String(aircraft.params.height).replace('.', ',')} />
                <Facility title={tMsg('Багаж')} value={aircraft.facilities.baggage} />
                <Facility title={tMsg('Питание')} value={aircraft.facilities.food} />
                <Facility title={tMsg('Стюардесса')} value={aircraft.facilities.stewardess} />
            </React.Fragment>
        case '3':
        default:
            return <React.Fragment>
                <Facility title={tMsg('Мест')} value={aircraft.params.seats.value} />
                <Facility title={tMsg('Выс.салона')} value={`${String(aircraft.params.height.value).replace('.', ',')} ${aircraft.params.height.units}`} />
                <Facility title={tMsg('Багаж')} value={aircraft.facilities.baggage.label} />
                <Facility title={tMsg('Питание')} value={aircraft.facilities.food.label} />
                <Facility title={tMsg('Стюардесса')} value={aircraft.facilities.stewardess.label} />
            </React.Fragment>
    }

}

function Facility({ title, value }) {
    return <div className="flight-info">
        <span>{title}</span>
        {value}
    </div>
}

export function ExpireTimer({ expiresAt, onExpire }) {
    
    const secondsLeft = React.useMemo(() => {
        const expires = window.moment(expiresAt)
        if (expires.isBefore()) {
            return 0
        }
        
        return expires.diff(window.moment(), 'seconds')
    }, [ expiresAt ])
    
    return <div className="flight-price__info">
        <div className="flight-control__timer">
            <span><TimerWidget seconds={secondsLeft} showUnits={true} onExpire={onExpire} /></span>
            {secondsLeft > 0 ? __('userflight.expire.text') : __('userflight.expired.text')}
        </div>
    </div>
}
